import Joi from '@hapi/joi'

export const fieldSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group cannot have invalid characters`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Estate cannot have invalid characters`,
        "any.required": `Estate required`
    }),
    collectionPointID: Joi.number().invalid(0).required().label("Division").messages({
        "any.invalid": `Division cannot have invalid characters`,
        "any.required": `Division required`
    }),
    fieldCode: Joi.string().required().min(2).max(2).label("Field Code").regex(/^\w+(?:\s+\w+)*$/).messages({
        "string.empty": `Field required`,
        "string.pattern.base": `Field cannot have invalid characters`,
        "string.min": `Please enter {#limit} digit number`,
        "string.max": `Please enter {#limit} digit number`
    }),
    fieldName: Joi.string().required().label("Field Name").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Field Name required`,
        "string.pattern.base": `Please enter valid field name`,
    }),
    fieldLocation: Joi.string().label("Field Location").allow("", null).regex(/^(?!\s*$).+/),
    areaofaSection: Joi.number().positive().invalid(0).required().label("Area Of a Section").messages({
        "any.invalid": `Area Of a Section cannot have invalid characters`,
        "any.required": `Area Of a Section required`
    }),
    yearofPlanting: Joi.string().isoDate().required(),
    typesofPlantsID: Joi.number().invalid(0).required().label("Types of Plants").messages({
        "any.invalid": `Types of Plants cannot have invalid characters`,
        "any.required": `Types of Plants required`
    }),
    drainageLengths: Joi.number().positive().invalid(0).required().label("Drainage Lengths").messages({
        "any.invalid": `Drainage Lengths cannot have invalid characters`,
        "any.required": `Drainage Lengths required`
    }),
    spaceBetweenPlants: Joi.number().positive().invalid(0).required().label("Space Between Plants").messages({
        "any.invalid": `Space Between Plants cannot have invalid characters`,
        "any.required": `Space Between Plants required`
    }),
    numberOfTeaBushes: Joi.number().positive().invalid(0).required().label("Number Of Tea Bushes").messages({
        "string.pattern.base": `Field cannot have invalid characters`,
        "any.invalid": `Number Of Tea Bushes cannot have invalid characters`,
        "any.required": `Number Of Tea Bushes required`
    }),
    plantingTypeID: Joi.number().invalid(0).required().label("Planting Type").messages({
        "any.invalid": `Planting Type cannot have invalid characters`,
        "any.required": `Planting Type required`
    }),
    numberOfShadeTrees: Joi.number().positive().invalid(0).required().label("Number Of Shade Trees").messages({
        "any.invalid": `Number Of Shade Trees cannot have invalid characters`,
        "any.required": `Number Of Shade Trees required`
    }),
    isActive: Joi.boolean().label("Active")
}


export const fieldFilteringSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Please Select the Valid Group`,
        "any.required": `Group required`
    }),

    estateID: Joi.number().invalid(0).required().label("Estate Name").messages({
        "any.invalid": `Please Select the Valid Estate`,
        "any.required": `Estate required`
    }),

    collectionPointCategoryID: Joi.number().invalid().required().label("Division Name").messages({
        "any.invalid": `Please Select the Valid Division`,
        "any.required": `Division required`
    })
}














